import React from 'react'

export const HorizontalDim = ({
  min, max, wholeWidth,
}) => {
  const isEmpty = min < 1 && max < 1

  return (
    <div style={{
      width: '100%', height: '8px', paddingLeft: '16px', marginBottom: '8px',
    }}
    >
      <div style={{
        position: 'relative',
        height: '100%',
        left: `${min}px`,
        width: `${max}px`,
        border: isEmpty ? null : '2px solid #DDDDDD',
        borderTop: isEmpty ? null : 'none',
        textAlign: 'center',
      }}
      >
        <span style={{
          backgroundColor: 'white',
          fontSize: '0.8em',
          position: 'relative',
          top: '-0.7em',
          padding: '0 10px',
        }}
        >
          {wholeWidth > 0 ? `${wholeWidth}cm` : null}
        </span>
      </div>

    </div>
  )
}

export const VerticalDim = ({
  divHeight, min, max, wholeHeight,
}) => (

  <div style={{ width: '8px', height: `${divHeight}px`, marginRight: '8px' }}>
    <div style={{
      position: 'relative',
      width: '100%',
      top: `${min}px`,
      height: `${max}px`,
      border: (min < 1 && max < 1) ? null : '2px solid #DDDDDD',
      borderLeft: (min < 1 && max < 1) ? null : 'none',
    }}
    >
      <span style={{
        position: 'relative',
        fontSize: '0.8em',
        backgroundColor: 'white',
        padding: '10px 0',
        top: `${(max / 2) - 20}px`,
        left: '-0.4em',
        writingMode: 'tb-rl',
        transform: 'rotate(-180deg)',
      }}
      >
        {wholeHeight > 0 ? `${wholeHeight}cm` : null}
      </span>
    </div>

  </div>
)
